import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SenecScreenTemplate } from "../SenecScreenTemplate";
import { SenecButton } from "@newsenec/ui-components";
import { FPPError } from "@newsenec/logging";

interface RetryScreenProps {
    error?: FPPError;
    message?: string;
    "data-testid"?: string;
    onRetry?: () => void;
}

export const RetryScreen = ({ error, message, onRetry, ...rest }: RetryScreenProps) => {
    const { t } = useTranslation();

    return (
        <SenecScreenTemplate
            data-testid={rest["data-testid"] ?? "login-retry-screen"}
            title={t("retryScreenProblemOccurredTitle")}
            content={
                <>
                    <Typography sx={{ whiteSpace: "pre-line", textAlignLast: "center" }}>
                        {message ?? t("retryScreenMessage")}
                    </Typography>
                    {error && (
                        <Typography>{`${t("retryScreen.error.errorId")}: ${error.errorCode}, ${error.errorTraceId}`}</Typography>
                    )}
                </>
            }
            footer={
                <Box>
                    <SenecButton
                        level="primary"
                        onClick={() => {
                            onRetry ? onRetry() : window.location.reload();
                        }}
                    >
                        {t("retryScreenRetryLabel")}
                    </SenecButton>
                </Box>
            }
        />
    );
};
